import {AfterViewInit, ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {DatePipe, NgClass, NgIf, NgOptimizedImage} from "@angular/common";
import {TranslateModule, TranslatePipe} from "@ngx-translate/core";
import {TNewsItem} from "../../../pages/about-us/about.types";
import {Router} from "@angular/router";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/all";

@Component({
  selector: 'app-news-list',
  imports: [
    TranslateModule,
    NgClass,
    NgIf,
  ],
  templateUrl: './news-list.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsListComponent {
  newsList = input<TNewsItem[]>([]);
  #router = inject(Router);

  openNewInfo(id: string): void {
    this.#router.navigate(['/news', id]).then(() => {});
  }

}
